import "./NotFound.less";
import * as React from "react";
import { AtTitle } from "@atman/design-system";

export const NotFound: React.FunctionComponent = () => (
    <div className={"NotFound"}>
        <AtTitle headingType={3} title={"global.pageNotFoundText".localize()} />
    </div>
);
